<template>
  <div class="mobile-navbar">
    <!-- 顶部导航栏 -->
    <nav class="navbar-header">
      <div class="navbar-left">
        <img class="logo" src="@/assets/img/com/mobile/logo.png" alt="智寰科技" @click="navigateTo(0)" />
      </div>
      <div class="navbar-right">
        <!-- 临时测试按钮 -->
        <div class="menu-toggle" @click.stop="toggleMenu" :class="{ active: isMenuOpen }">
          <!-- 汉堡菜单图标 -->
          <div class="hamburger" v-if="!isMenuOpen" @click.stop="toggleMenu">
            <!-- <span></span>
            <span></span>
            <span></span> -->
            点击展开
          </div>
          <!-- 关闭图标 -->
          <div class="close-icon" v-else @click.stop="toggleMenu">
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </nav>

    <!-- 弹出菜单 -->
    <div class="menu-overlay" v-if="isMenuOpen" @click="closeMenu">
      <div class="menu-content" @click.stop>
        <nav class="navbar-header">
          <div class="navbar-left">
            <img class="logo" src="@/assets/img/com/mobile/logo.png" alt="智寰科技" @click="navigateTo(0)" />
          </div>
          <div class="navbar-right">
            <div class="menu-toggle" @click.stop="closeMenu">
              <!-- 关闭图标 -->
              <div class="close-icon">
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </nav>
        <ul class="menu-list">
          <li :class="{ active: activeIndex === 0 }" @click="navigateTo(0)">
            <span>首页</span>
          </li>
          <li :class="{ active: activeIndex === 1 }" @click="navigateTo(1)">
            <span>产品介绍</span>
          </li>
          <li :class="{ active: activeIndex === 2 }" @click="navigateTo(2)">
            <span>产品定价</span>
          </li>
          <li :class="{ active: activeIndex === 3 }" @click="navigateTo(3)">
            <span>产品下载</span>
          </li>
          <li :class="{ active: activeIndex === 4 }" @click="navigateTo(4)">
            <span>公司介绍</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    navigateTo(index) {
      this.$emit('update:activeIndex', index)
      const routes = ['/', '/product', '/price', '/download', '/about']
      this.$router.push(routes[index])
      this.closeMenu() // 导航后关闭菜单
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      // 防止背景滚动
      if (this.isMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    closeMenu() {
      this.isMenuOpen = false
      document.body.style.overflow = ''
    }
  },
  beforeDestroy() {
    // 组件销毁时恢复滚动
    document.body.style.overflow = ''
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/mobile-responsive.scss' as mobile;

.mobile-navbar {
  position: relative;

  // 顶部导航栏
  .navbar-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: mobile.px2rem(44);
    background: #fff;
    border-bottom: 1px solid #eee;
    z-index: 1001;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 mobile.px2rem(15);

    .navbar-left {
      .logo {
        height: mobile.px2rem(24);
        width: auto;
        cursor: pointer;
      }
    }

    .navbar-right {
      .menu-toggle {
        width: mobile.px2rem(65);
        height: mobile.px2rem(40);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        position: relative;
        z-index: 1003;
        background: transparent;
        border: none;

        &:hover {
          // background: rgba(0, 0, 0, 0.05);
          // border-radius: mobile.px2rem(4);
        }

        &:active {
          // background: rgba(0, 0, 0, 0.1);
        }

        // 汉堡菜单样式
        .hamburger {
          span {
            display: block;
            width: mobile.px2rem(20);
            height: mobile.px2rem(2);
            background: #333;
            margin: mobile.px2rem(3) 0;
            transition: 0.3s;
            border-radius: mobile.px2rem(1);
          }
        }

        // 关闭图标样式
        .close-icon {
          position: relative;
          width: mobile.px2rem(20);
          height: mobile.px2rem(20);

          span {
            position: absolute;
            top: 50%;
            left: 0;
            width: mobile.px2rem(20);
            height: mobile.px2rem(2);
            background: #333;
            border-radius: mobile.px2rem(1);
            transition: 0.3s;

            &:first-child {
              transform: translateY(-50%) rotate(45deg);
            }

            &:last-child {
              transform: translateY(-50%) rotate(-45deg);
            }
          }
        }
      }
    }
  }

  // 弹出菜单遮罩
  .menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1002;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 0;

    .menu-content {
      width: 100%;
      height: 100%;
      background: #fff;
      animation: slideDown 0.3s ease-out;

      // 弹出菜单中的导航栏需要添加底部边框
      .navbar-header {
        border-bottom: 1px solid #eee;
      }

      .menu-list {
        list-style: none;
        margin: 0;
        padding-top: mobile.px2rem(44); // 给导航栏留出空间

        li {
          padding: mobile.px2rem(20) mobile.px2rem(20);
          border-bottom: 1px solid #EBEBEB;
          cursor: pointer;
          transition: background-color 0.2s;
          text-align: center;

          &:hover {
            background-color: #f8f9fa;
          }

          &.active {

            span {
              color: #333333;
              font-weight: 800;
            }
          }

          span {
            font-size: mobile.px2rem(15);
            color: #333;
            font-weight: 500;
          }
        }
      }
    }
  }
}

// 动画效果
@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }

  to {
    transform: translateY(0);
  }
}
</style>
